import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  Center,
  FormControl,
  FormLabel,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Select,
  ModalFooter,
  VStack,
  Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobEducationCourseAsync,
  deleteJobEducationCourseAsync,
  fetchEducationCourseAsync,
  fetchJobEducationCourseAsync,
  selectJobEducationCourse,
  updateJobEducationCourseAsync,
} from "../../../JobPostingSlice/JobEducationCourse/JobEducationCourceSlice";
import { useForm } from "react-hook-form";
import {
  fetchJobEducationAsync,
  selectJobEducation,
} from "../../../JobPostingSlice/JobEducation/JobEducationSlice";

function JobEducationCourse() {
  const dispatch = useDispatch();
  const jobEducationCourse = useSelector(selectJobEducationCourse);


  useEffect(() => {
    dispatch(fetchEducationCourseAsync());
  }, [dispatch]);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [newJobEducationCourse, setNewJobEducationCourse] = useState("");
  const [newJobStatus, setNewJobStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editJobEducationCourse, setEditJobEducationCourse] = useState("");
  const [editJobEducation, setEditJobEducation] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobEducationCourse, setEditableJobEducationCourse] =
    useState(null);
  const [deletingEducationCourse, setDeletingEducationCourse] = useState(null);

  const jobEducation = useSelector(selectJobEducation);
  // console.log("job education", jobEducation);

  useEffect(() => {
    dispatch(fetchJobEducationAsync());
    dispatch(fetchEducationCourseAsync());
  }, [dispatch]);

  const handleDelete = async (uuid) => {
    // console.log("uuid", uuid)
    await dispatch(deleteJobEducationCourseAsync(uuid));
    await dispatch(fetchJobEducationCourseAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setDeletingEducationCourse(job);
    dispatch(fetchJobEducationCourseAsync());
    onOpen2();
  };

  const handleSave = async (newJobEducationCourse) => {
    try {
      // console.log("data", newJobEducationCourse);
      await dispatch(addJobEducationCourseAsync(newJobEducationCourse));
      // await dispatch(fetchJobEducationAsync());
      await dispatch(fetchEducationCourseAsync());
      onClose1();
      reset();
    } catch (error) {
      console.error("Failed to add project", error);
    }
  };

  const handleEdit = (jobTitle) => {
    // console.log("Job Education UUID:", jobTitle.core_job_education.uuid);
    setEditableJobEducationCourse(jobTitle);
    setEditJobEducationCourse(jobTitle.title);
    setEditJobStatus(jobTitle.status);
    setEditJobEducation(jobTitle.core_job_education.uuid); // Ensure this is correctly set
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editJobEducationCourse.trim()) {
      try {
        await dispatch(
          updateJobEducationCourseAsync({
            uuid: editableJobEducationCourse.uuid,
            jobEducationCourseData: {
              title: editJobEducationCourse,
              status: editJobStatus, // Include status
              job_education_uuid: editJobEducation, // Include jobEducation selection
            },
          })
        );

        await dispatch(fetchJobEducationCourseAsync());
        setEditableJobEducationCourse(null);
        setEditJobEducationCourse("");
        setEditJobStatus(""); // Reset status
        setEditJobEducation(""); // Reset jobEducation selection
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div
      className="h-screen bg-adminbg p-4 contentAdmin"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="">
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Job Education Course List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button colorScheme="blue" fontSize={"medium"} onClick={onOpen1}>
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1}>
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <div className="p-4">
                    <h4 className="py-2">Add Job Education Course:</h4>
                    <form onSubmit={handleSubmit(handleSave)}>
                      {/* Job Title Input */}
                      <Input
                        className="border-black"
                        color="black"
                        placeholder="Enter Job Education Course"
                        {...register("title", { required: true })}
                      />
                      {errors.title && (
                        <p className="text-red-500">This field is required</p>
                      )}

                      {/* Job Status Input */}
                      <Input
                        className="border-black"
                        color="black"
                        placeholder="Enter Job Education Course Status"
                        {...register("status", { required: true })}
                      />
                      {errors.status && (
                        <p className="text-red-500">This field is required</p>
                      )}

                      {/* Job Education Select Field */}
                      <Select
                        className="border-black"
                        color="black"
                        placeholder="Select Job Education"
                        {...register("job_education_uuid", { required: true })}
                      >
                        {Array.isArray(jobEducation) &&
                          jobEducation.map((education) => (
                            <option key={education.id} value={education.uuid}>
                              {education.title}
                            </option>
                          ))}
                      </Select>
                      {errors.jobEducation && (
                        <p className="text-red-500">This field is required</p>
                      )}

                      {/* Buttons */}
                      <div className="w-full flex justify-center gap-2 mt-5">
                        <Button
                          colorScheme="blue"
                          className="w-64"
                          type="submit"
                        >
                          Save
                        </Button>
                        <Button
                          colorScheme="blue"
                          textColor={"blue"}
                          variant={"outline"}
                          className="w-64"
                          onClick={onClose1}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>

          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">Degree</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(jobEducationCourse) &&
                  jobEducationCourse.map((job) => (
                    <Tr key={job.id}>
                      <Td>{job?.core_job_education?.title}</Td>
                      <Td>{job.title}</Td>
                      <Td textColor={"green"}>{job.status}</Td>
                      <Td>
                        <div className="text-sm opacity-90 text-blue-700 flex">
                          <div>
                            <i className="fa-solid fa-eye mr-3.5"></i>
                          </div>
                          <div>
                            <button onClick={() => handleEdit(job)}>
                              <i className="fa-solid fa-pencil mr-3.5"></i>
                            </button>
                            <Modal
                              isOpen={isEditModalOpen}
                              onClose={() => setIsEditModalOpen(false)}
                            >
                              <ModalOverlay />
                              <ModalContent maxW="2xl">
                                <ModalHeader>
                                  Edit Job Education Course
                                </ModalHeader>
                                <ModalCloseButton />
                                <ModalBody>
                                  <VStack spacing={4} align="stretch">
                                    {/* Job Title Input */}
                                    <FormControl>
                                      <FormLabel>Job Education Course</FormLabel>
                                      <Input
                                        className="border-black"
                                        color="black"
                                        placeholder="Enter Job Education Course title"
                                        value={editJobEducationCourse}
                                        onChange={(e) =>
                                          setEditJobEducationCourse(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </FormControl>

                                    {/* Job Status Input */}
                                    <FormControl>
                                      <FormLabel>Job Status</FormLabel>
                                      <Input
                                        className="border-black"
                                        color="black"
                                        placeholder="Enter Job Education Course status"
                                        value={editJobStatus}
                                        onChange={(e) =>
                                          setEditJobStatus(e.target.value)
                                        }
                                      />
                                    </FormControl>

                                    {/* Job Education Dropdown */}
                                    <FormControl>
                                      <FormLabel>Job Education</FormLabel>
                                      <Select
                                        className="border-black"
                                        color="black"
                                        placeholder="Select Job Education"
                                        value={editJobEducation}
                                        onChange={(e) =>
                                          setEditJobEducation(e.target.value)
                                        }
                                      >
                                        {Array.isArray(jobEducation) &&
                                          jobEducation.map((education) => (
                                            <option
                                              key={education.uuid}
                                              value={education.uuid}
                                            >
                                              {education.title}
                                            </option>
                                          ))}
                                      </Select>
                                    </FormControl>
                                  </VStack>

                                  {/* Error Message */}
                                  {error && (
                                    <Text color="red.500">{error}</Text>
                                  )}
                                </ModalBody>

                                <ModalFooter>
                                  <Button
                                    colorScheme="blue"
                                    w="50%"
                                    onClick={handleUpdate}
                                  >
                                    Update
                                  </Button>
                                  <Button
                                    colorScheme="blue"
                                    variant="outline"
                                    w="50%"
                                    onClick={() => setIsEditModalOpen(false)}
                                  >
                                    Cancel
                                  </Button>
                                </ModalFooter>
                              </ModalContent>
                            </Modal>
                          </div>
                          <div className="">
                            <button onClick={() => openDeleteModal(job)}>
                              <i className="cursor-pointer fa-solid fa-trash-can-arrow-up mr-3.5"></i>
                            </button>
                            <Modal
                              isOpen={isOpen2}
                              onClose={onClose2}
                              alignContent={Center}
                            >
                              <ModalOverlay />
                              <ModalContent maxW={"2xl"}>
                                <div className="p-4">
                                  <h4 className="py-2">
                                    Are you sure you want to delete "
                                    {deletingEducationCourse?.title}"?
                                  </h4>
                                  <div className="w-full flex justify-center gap-2 mt-4">
                                    <Button
                                      colorScheme="red"
                                      className="w-48"
                                      onClick={() =>
                                        handleDelete(
                                          deletingEducationCourse.uuid
                                        )
                                      }
                                    >
                                      Delete
                                    </Button>
                                    <Button
                                      colorScheme="red"
                                      textColor={"red"}
                                      variant={"outline"}
                                      className="w-48"
                                      onClick={onClose2}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                </div>
                              </ModalContent>
                            </Modal>
                          </div>
                        </div>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobEducationCourse;
